import { IRoleDB } from 'src/app/auth/components/login/interfaces/menu.interface';

export const USER_TTL_ES = 'USUARIOS';
export interface IUserBase {
  names: string;
  surnames: string;
  username: string;
  roleId: number;
  password: string;
  branchStoresIds: number[];
}
export interface IUser extends IUserBase {
  id: number;
}
export interface IUserTable extends IUser {
  role: IRoleDB;
}

export type IUserUpdate = Partial<IUserBase>;
export interface IUserFormUpdate extends Partial<IUserBase> {
  restartPassword: boolean;
}
